<template>
  <div class="checkIn-page">
    <Header :title="title" :goBackHandler="goBack">
      <template slot="right-sum">
        <router-link :to="{name:'MyCheckIn'}">我的打卡</router-link>
      </template>
    </Header>
    <div class="checkIn-fitler">
      <van-tabs @click="onTabChange"
                title-active-color="#333333"
                title-inactive-color="#BEBEBE"
                line-width="8vw"
                line-height="0.53333vw"
                :ellipsis="false"
                :border="false"
                class="filter1">
        <van-tab v-for="(item,index) in classifyList"
                 :title="item.title"
                 :key="index">
        </van-tab>
      </van-tabs>
    </div>
    <div class="lines"></div>
    <div class="page_list">
      <List ref="list"
            :showText="list.length?true:false"
            url="/api/app/checkin"
            method="get"
            :params="params"
            :on-getdata="onGetdata">
        <checkInItem class="page_item"
                     slot="item"
                     :statusImg='item.status==1?noStartImg:startImg'
                     :data="item"
                     v-for="(item,index) in list"
                     :key="index"
                     @goHomePage="goHomePage">
          <div slot="btn"
               @click.stop="join(item)">{{getStatus(item.join_status)}}</div>
        </checkInItem>
      </List>
    </div>
  <Empty v-if="!list.length"
           :empty_type="{name: '暂无打卡'}"></Empty>
  </div>
</template>

<script>
import Header from "@/components/Header";
import List from "@/components/List";
import CheckInItem from "@/components/checkIn/CheckInItem";
import startImg from '@/assets/images/checkIning.png';
import noStartImg from '@/assets/images/noStart.png';
import Empty from "@/components/Empty";
export default {
  name: "checkIn",
  components: {
    List,
    Header,
    CheckInItem,
    Empty
  },
  data () {
    return {
      startImg: startImg,
      noStartImg: noStartImg,
      title: {
        name: "打卡列表"
      },
      attrclassify: [],
      classify_id: this.$store.state.personInfo.classify_id || localStorage.classify_id,
      params: {},
      classifyList: [],
      list: [{ id: '1' }],
    };
  },
  created () {
    this.params.classify_id = this.classify_id;
    this.getClassifyList();
  },
  methods: {
    goBack () {
      if (this.$store.state.app) {
        this.$pub.appAction("closeAppPage");
      } else{
        this.$router.go(-1);
      }
    },
    getStatus (status) {
      if (status == 0) {
        return '加入打卡';
      } else if (status == 1) {
        return '已加入';
      } else if (status == 2) {
        return '已退出'
      }
    },
    getClassifyList () {
      let param = { classify_id: this.classify_id };
      this.$pub.getClassify(param).then(res => {
        if (res.length > 0) {
          this.classifyList = res;
        }
        this.classifyList.unshift({ id: this.classify_id, title: '全部' });
      })
    },
    onGetdata (data) {
      this.list = data;
    },
    onTabChange (index) {
      this.params.classify_id = this.classifyList[index].id;
      this.$refs.list.reset();
    },
    join (item) {
      if (item.join_status == 0) {
        this.$http.post(`/api/app/checkin/join/${item.id}`).then((res) => {
          item.join_status = 1;
          item.people++;
          this.$toast('加入打卡成功');
        });
      }
    },
    /**
     * 点击卡片去打卡主页
     */
    goHomePage (data) {
      this.$router.push({ name: 'Homepage', query: { id: data.id } });
    }
  },
  watch: {
    $route (val) {
      if (val.name == "CheckIn") {
        this.$refs.list.reset();
        this.getClassifyList();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.checkIn-page {
  min-height: 100vh;
  background: #ffffff;
  a {
    color: #666666;
  }
  .lines {
    height: 30px;
    background-color: #f6f6f6;
  }
  .page_list {
    margin: 30px;
    /deep/ {
      .page_item {
        border-bottom: 1px solid #f6f6f6;
      }
      .van-list > div:nth-last-of-type(3) {
        border-bottom: none;
      }
    }
  }
}
</style>
